// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_p7-5";
export var filledCircle = "_p7-4";
export var historyEntry = "_p7-3";
export var messageSideLeft = "_p7-1";
export var messageSideRight = "_p7-2";
export var orderTrackingCarouselWrapper = "_p7-6";
export var orderTrackingInfoContainer = "_p7-0";